import { useEffect, useState } from 'react'
import Modal from '../Modal'
import DatePicker from '../DatePicker'
import TextAreaField from '../TextAreaField'
import {
  CreateIntegrationSigningCredentialModel,
} from '../../redux/types'

interface Props {
  visible: boolean
  onAddClick?: (credential: CreateIntegrationSigningCredentialModel) => void
  onCancelClick?: () => void
}

const AddIntegrationSigningCredentialModal = ({ visible, onAddClick, onCancelClick }: Props) => {
  const [publicCertificate, setPublicCertificate] = useState('')
  const [activeFrom, setActiveFrom] = useState(new Date().toISOString())
  const [expiresAt, setExpiresAt] = useState<string | null>(null)

  useEffect(() => {
    if (visible) {
      setPublicCertificate('')
      setActiveFrom(new Date().toISOString())
      setExpiresAt(null)
    }
  }, [visible])

  const handleOnAdd = () => {
    onAddClick && onAddClick({
      publicCertificate,
      activeFrom,
      expiresAt
    })
  }

  const handleOnClose = () => {
    onCancelClick && onCancelClick()
  }

  return (
    <Modal
      title='Add signing credential'
      show={visible}
      okButtonTitle='Add'
      cancelButtonTitle='Cancel'
      onHide={handleOnClose}
      onOkClick={handleOnAdd}
      onCancelClick={handleOnClose}
    >
      <DatePicker
        id='activeFrom'
        label='Active from'
        includeTime={true}
        value={activeFrom}
        onChange={value => setActiveFrom(value ?? new Date().toISOString())}
      />
      <DatePicker
        id='expiresAt'
        label='Expires at'
        includeTime={true}
        value={expiresAt ?? undefined}
        onChange={value => setExpiresAt(value ?? null)}
      />
      <TextAreaField
        id='publicCertificate'
        label='Public certificate'
        value={publicCertificate}
        rows={8}
        onChange={event => setPublicCertificate(event.target.value)}
      />
    </Modal>
  )
}

export default AddIntegrationSigningCredentialModal
